import { useState, createContext, useContext } from "react";
import { handleData } from "../api";
import { sortActiviteitenByDate, stringToDate } from "../helperfunctions/helperfunctions";
import { useAuth } from "./auth";

const ActiviteitenContext = createContext(null);

export const ActiviteitenProvider = ({ children }) => {

    const auth = useAuth();

    const [activiteiten, setActiviteiten] = useState(null);
    const [futureActiviteiten, setFutureActiviteiten] = useState([]);
    const [pastActiviteiten, setPastActiviteiten] = useState([]);
    const [soonActiviteiten, setSoonActiviteiten] = useState([]);

    // lijst met activiteiten waar nog vrijwilligers voor gezocht worden
    const [openActiviteiten, setOpenActiviteiten] = useState([]);
    // const [myPastActiviteiten, setMyPastActiviteiten] = useState([]);
    const [myActiviteiten, setMyActiviteiten] = useState([]);

    const [loadingMessage, setLoadingMessage] = useState('');

    const loadActiviteiten = async() => {
        const data = {
            method: 'GET',
            path: 'activiteiten'
        }
        setLoadingMessage('Data wordt geladen');
        const result = await handleData(data);
        if (result.data.data) {
            const sortedActiviteiten = result.data.data;
            sortActiviteitenByDate(sortedActiviteiten);
            setActiviteiten(sortedActiviteiten);
            setLoadingMessage('');

            const today = new Date();
            const futureActiviteiten = sortedActiviteiten.filter(item=> {
                const itemDate = stringToDate(item.datum);
                return today <= itemDate;
            });
            const pastActiviteiten = sortedActiviteiten.filter(item=> {
                const itemDate = stringToDate(item.datum);
                return today >= itemDate;
            });
            setFutureActiviteiten(futureActiviteiten);
            setPastActiviteiten(pastActiviteiten);


            const currentMonth = today.getMonth();
            
            const soonActiviteiten = futureActiviteiten.filter(item => {
                const itemDate = stringToDate(item.datum);
                const itemMonth = itemDate.getMonth();
                
                return itemMonth === 11 ? ( itemMonth === 11 || itemMonth === 0 ):( itemMonth === currentMonth || itemMonth === (currentMonth + 1));
            });
            setSoonActiviteiten(soonActiviteiten);


            const getOpenActiviteiten = futureActiviteiten.filter(item => {

                const aantalTaken = item.taken.length;
                for (let i = 0; i < aantalTaken; i++) {
                    if (!item.taken[i].vrijwilliger) {
                        return true;
                    }
                }
            });
            setOpenActiviteiten(getOpenActiviteiten);

            const filterMyActiviteiten = futureActiviteiten.filter(item => {
                const aantalTaken = item.taken.length;
                for (let i = 0; i < aantalTaken; i++) {
                    if (item.taken[i].vrijwilliger) {
                        if (item.taken[i].vrijwilliger._id === auth.user._id) {
                            return true;
                        }
                    }
                }
            });
            setMyActiviteiten(filterMyActiviteiten);
        
        } else {
            setLoadingMessage("Er is iets misgegaan bij het laden van de data. Probeer het later nog eens.");

        }
        
    }


    return (
        <ActiviteitenContext.Provider
            value={{
                activiteiten,
                futureActiviteiten,
                pastActiviteiten,
                soonActiviteiten,
                openActiviteiten,
                myActiviteiten,
                loadingMessage,
                loadActiviteiten
            }}
        >
            {children}
        </ActiviteitenContext.Provider>
    );

}

export const useActiviteiten = () => {
    return useContext(ActiviteitenContext);
}